export interface PageSEO {
  title: {
    es: string;
    en: string;
  };
  description: {
    es: string;
    en: string;
  };
  keywords: {
    es: string;
    en: string;
  };
}

export const pageSEO: Record<string, PageSEO> = {
  home: {
    title: {
      es: 'ERP en la Nube México | Sistema Gestión Manufactura | LAIMU',
      en: 'Cloud ERP Mexico | Manufacturing Management System | LAIMU'
    },
    description: {
      es: 'Software ERP en la nube #1 para manufactura en México. CFDI 4.0, Carta Porte, nómina integrada. +500 empresas confían en LAIMU. Demo gratuita.',
      en: 'Mexico #1 cloud ERP for manufacturing. CFDI 4.0, Carta Porte, integrated payroll. 500+ companies trust LAIMU. Free demo available.'
    },
    keywords: {
      es: 'ERP en la nube México, sistema gestión manufactura, software nómina México, ERP manufactura México, CFDI 4.0, Carta Porte, ERP Monterrey, software automotriz, gestión empresarial México',
      en: 'cloud ERP Mexico, manufacturing management system, payroll software Mexico, ERP manufacturing Mexico, CFDI 4.0, Carta Porte, ERP Monterrey, automotive software'
    }
  },
  solutions: {
    title: {
      es: 'Módulos ERP México: CRM, TMS, MRP, HRMS, Nómina | LAIMU',
      en: 'ERP Modules Mexico: CRM, TMS, MRP, HRMS, Payroll | LAIMU'
    },
    description: {
      es: 'Módulos ERP integrados: Gestión comercial CRM, Transporte TMS con Carta Porte, Manufactura MRP, Recursos Humanos HRMS y nómina. Todo en una plataforma.',
      en: 'Integrated ERP modules: CRM commercial management, TMS transport with Carta Porte, MRP manufacturing, HRMS & payroll. All-in-one platform.'
    },
    keywords: {
      es: 'módulos ERP México, CRM México, TMS Carta Porte, MRP manufactura, HRMS nómina, software gestión comercial, sistema transporte México, planificación producción',
      en: 'ERP modules Mexico, CRM Mexico, TMS Carta Porte, MRP manufacturing, HRMS payroll, commercial management software, transport system Mexico, production planning'
    }
  },
  erp: {
    title: {
      es: 'ERP Contabilidad México | CFDI 4.0 | Facturación SAT | LAIMU',
      en: 'ERP Accounting Mexico | CFDI 4.0 | SAT Invoicing | LAIMU'
    },
    description: {
      es: 'Sistema ERP contabilidad con cumplimiento total SAT. Facturación CFDI 4.0, contabilidad electrónica certificada, multi-empresa. Prueba gratuita.',
      en: 'ERP accounting system with full SAT compliance. CFDI 4.0 invoicing, certified electronic accounting, multi-company. Free trial.'
    },
    keywords: {
      es: 'ERP contabilidad México, CFDI 4.0, facturación SAT, contabilidad electrónica, sistema contable México, cumplimiento fiscal, ERP multi-empresa',
      en: 'ERP accounting Mexico, CFDI 4.0, SAT invoicing, electronic accounting, accounting system Mexico, tax compliance, multi-company ERP'
    }
  },
  tms: {
    title: {
      es: 'TMS Carta Porte México | Software Logística | Gestión Flota',
      en: 'TMS Carta Porte Mexico | Logistics Software | Fleet Management'
    },
    description: {
      es: 'Sistema TMS con generación automática Complemento Carta Porte. Optimización rutas, gestión flota, GPS en tiempo real. Cumplimiento total SCT.',
      en: 'TMS system with automatic Carta Porte Complement generation. Route optimization, fleet management, real-time GPS. Full SCT compliance.'
    },
    keywords: {
      es: 'TMS México, Carta Porte automática, software logística, gestión flota México, optimización rutas, transporte mercancías, complemento carta porte, SCT',
      en: 'TMS Mexico, automatic Carta Porte, logistics software, fleet management Mexico, route optimization, freight transport, carta porte complement, SCT'
    }
  },
  manufacturing: {
    title: {
      es: 'Software Manufactura México | MRP Sistema Producción | LAIMU',
      en: 'Manufacturing Software Mexico | MRP Production System | LAIMU'
    },
    description: {
      es: 'Sistema MRP para manufactura: Planificación producción, control inventarios, BOM, calidad, costos. Industria automotriz, electrónica, empaque.',
      en: 'MRP system for manufacturing: Production planning, inventory control, BOM, quality, costs. Automotive, electronics, packaging industries.'
    },
    keywords: {
      es: 'software manufactura México, MRP sistema, planificación producción, control inventarios, industria automotriz, software industrial México, BOM',
      en: 'manufacturing software Mexico, MRP system, production planning, inventory control, automotive industry, industrial software Mexico, BOM'
    }
  },
  hrms: {
    title: {
      es: 'Software Nómina México | HRMS Recursos Humanos | Sistema RH',
      en: 'Payroll Software Mexico | HRMS Human Resources | HR System'
    },
    description: {
      es: 'Sistema HRMS nómina México: Cálculo nómina automático, timbrado CFDI, control asistencia, reclutamiento, evaluación desempeño. Prueba gratis.',
      en: 'HRMS payroll system Mexico: Automatic payroll calculation, CFDI stamping, attendance control, recruitment, performance evaluation. Free trial.'
    },
    keywords: {
      es: 'software nómina México, HRMS México, sistema recursos humanos, cálculo nómina automático, control asistencia, software RH México, timbrado nómina',
      en: 'payroll software Mexico, HRMS Mexico, human resources system, automatic payroll calculation, attendance control, HR software Mexico, payroll stamping'
    }
  },
  industries: {
    title: {
      es: 'ERP Industrias México: Automotriz, Logística, Manufactura',
      en: 'ERP Industries Mexico: Automotive, Logistics, Manufacturing'
    },
    description: {
      es: 'ERP especializado por industria: Automotriz, manufactura, logística, impresión, contabilidad. Soluciones adaptadas a necesidades específicas.',
      en: 'Industry-specialized ERP: Automotive, manufacturing, logistics, printing, accounting. Solutions tailored to specific needs.'
    },
    keywords: {
      es: 'ERP automotriz México, ERP manufactura, software logística, ERP industria, soluciones verticales, ERP sector automotriz, software industrial',
      en: 'automotive ERP Mexico, manufacturing ERP, logistics software, industry ERP, vertical solutions, automotive sector ERP, industrial software'
    }
  },
  demo: {
    title: {
      es: 'Demo Gratuita ERP México | Solicitar Demostración | LAIMU',
      en: 'Free ERP Demo Mexico | Request Demonstration | LAIMU'
    },
    description: {
      es: 'Solicita demo gratuita de LAIMU ERP. Descubre cómo optimizar tu manufactura, logística y nómina. Asesoría personalizada sin compromiso.',
      en: 'Request free LAIMU ERP demo. Discover how to optimize your manufacturing, logistics and payroll. Personalized consulting without commitment.'
    },
    keywords: {
      es: 'demo ERP México, prueba gratuita ERP, demostración software, solicitar demo, ERP gratis, consultoría ERP México',
      en: 'ERP demo Mexico, free ERP trial, software demonstration, request demo, free ERP, ERP consulting Mexico'
    }
  },
  blog: {
    title: {
      es: 'Blog LAIMU | ERP, CFDI, Manufactura y Tecnología México',
      en: 'LAIMU Blog | ERP, CFDI, Manufacturing & Technology Mexico'
    },
    description: {
      es: 'Artículos de expertos sobre ERP, CFDI 4.0, Carta Porte, manufactura, logística, nómina y transformación digital en México.',
      en: 'Expert articles on ERP, CFDI 4.0, Carta Porte, manufacturing, logistics, payroll, and digital transformation in Mexico.'
    },
    keywords: {
      es: 'blog ERP México, CFDI 4.0, Carta Porte, manufactura, logística, nómina, transformación digital, software empresarial',
      en: 'ERP blog Mexico, CFDI 4.0, Carta Porte, manufacturing, logistics, payroll, digital transformation, business software'
    }
  }
};
